import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css'; // Adicione estilos personalizados

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className="cookie-banner">
        <p>
          Este site utiliza cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa política de cookies.
        </p>
        <button onClick={handleAccept} className="cookie-button">
          Aceitar
        </button>
      </div>
    )
  );
};

export default CookieConsent;